import React from 'react';

import View from './view';
import {Props} from './model';

export const NameInfoText = (props: Props) => {
  return <View {...props} />;
};
